<script>
    export let question, last
    let open = false

    function toggle() {
        open = !open
    }
</script>

<style type="text/scss">.wrapper {
  border-top: 1px solid #e5e5e5;
}

.wrapper.last {
  border-bottom: 1px solid #e5e5e5;
}

.wrapper .question {
  color: #333333;
}

.wrapper .question svg {
  transform: rotate(0deg);
  transition: all 0.2s ease-in-out;
}

.wrapper .question svg path {
  fill: currentColor;
}

.wrapper .question.open {
  color: #4081FF;
}

.wrapper .question.open svg {
  transform: rotate(-90deg);
}

.wrapper .answer {
  max-height: 0px;
  transition: max-height 0.3s ease-in, padding 0.2s ease-in;
}

.wrapper .answer.open {
  padding-bottom: 1.5rem;
  max-height: 500px;
}
/*# sourceMappingURL=src/components/FAQ.svelte.map */</style>

<div class="wrapper overflow-hidden" class:last>
    <div class="question font-semibold py-6 cursor-pointer flex justify-between items-center" class:open on:click={toggle}>
        <div class="text">{question}</div>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.49866 8.75005L14.9987 16.25L22.4987 8.75005L24.9987 11.25L14.9987 21.25L4.99866 11.25L7.49866 8.75005Z"
                fill="black" />
        </svg>
    </div>
    <div class="answer pr-6" class:open>
        <slot />
    </div>
</div>
